<template>
    <Modal
            v-model="_value"
            width="400"
            title="修改设备维修记录"
            @on-visible-change="visibleChange"
            ok-text="确认"
            @on-ok="onOk">
        <div style="position:relative;">
            <Form ref="maintainDeviceRecordRef" :model="maintainDeviceRecord" :label-width="80">
<!--                <FormItem prop="content" label="主机号">-->
<!--                    <Select v-model="maintainDeviceRecord">-->
<!--                        <Option v-for="item in devices" :value="item" :key="item.id">{{item.terminalNum+'('+ (item.positioningDeviceInfo.positioningDeviceModel == null ? '无' : item.positioningDeviceInfo.positioningDeviceModel.name) +')'}}</Option>-->
<!--                    </Select>-->
<!--                </FormItem>-->
                <FormItem label="维修结果">
                    <Input v-model="maintainDeviceRecord.result"></Input>
                </FormItem>
            </Form>
            <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="dataLoading">
                <Spin size="large"></Spin>
                <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
            </div>
        </div>
    </Modal>
</template>

<script>
    import Vue from 'vue';
    import {mapActions} from 'vuex'
    import store from '@/store'
    import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

    export default {
        name: "maintainorderaddmaintaindevicerecordresultmodal",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null
        },
        data(){
            return{
                devices: [],
                selectDevice: null,
                dataLoading: false,

                maintainDeviceRecord: {
                    terminalNum: null,
                    newTerminalNum: null,
                    newFactoryTerminalNum: null,
                    newPositioningDeviceModel: null,
                    newPositioningDeviceModelId: null,
                    changeDevice: false,
                    changeSim: false,
                    removeDevice: false,
                    positioningDeviceInfoId: null,
                    positioningDeviceInfo: null,
                    result: null,
                    maintainOrderId: null,
                }
            }
        },
        methods: {
            ...mapActions([
                'MaintainOrderServ_AddMaintainDeviceRecord'
            ]),
            onOk() {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确认添加</p>',
                    onOk: () => {
                        // this.maintainDeviceRecord = this.selectDevice
                        // console.log(this.selectDevice)
                        console.log(this.maintainDeviceRecord)
                        store.dispatch('MaintainOrderServ_ModifyMaintainDeviceRecord', {
                            params: this.maintainDeviceRecord
                        }).then(() => {
                            this.$Message.success('添加成功')
                            this.$emit('on-success')

                            // //确认订单
                            // store.dispatch('MaintainOrderServ_ConfirmMaintained', {
                            //     params: {id: this.maintainDeviceRecord.maintainOrderId}
                            // }).then(() => {
                            //     this.$Message.success('后台确认维修完成')
                            //     this.onLoad()
                            // }).catch(err => {
                            //     this.$Message.error(err)
                            // })

                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            visibleChange(val) {
                if (val) {
                    this.selectDevice = null
                    this.maintainDeviceRecord = this._initValue

                    // store.dispatch('MaintainOrderServ_GetDetail', {
                    //     params: {id: this._initValue},
                    //     urlparams: null
                    // }).then(() => {
                    //     if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords) {
                    //         this.devices = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords
                    //     }
                    // }).catch(err => {
                    //     this.$Message.error(err)
                    // })
                }
            }
        },
        computed: {
            _value: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _initValue: {
                get() {
                    return this.initValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            }
        },
        mounted() {
            this.$nextTick(() => {

            })
        }
    }
</script>

<style scoped>

</style>
